import React, { PropTypes } from "react";
import update from "react-addons-update";
import { connect } from "react-redux";
import { FieldArray } from "redux-form";
import { DropTarget } from "react-dnd";
import classNames from "classnames";

import { RenderLineItems } from "./";

class GuaranteeContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      guarantees: props.list,
    };

    this.moveGuarantee = this.moveGuarantee.bind(this);
    this.removeGuarantee = this.removeGuarantee.bind(this);
  }

  moveGuarantee(dragIndex, hoverIndex) {
    const { guarantees } = this.state;
    const dragGuarantee = guarantees[dragIndex];

    this.setState(
      update(this.state, {
        guarantees: {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragGuarantee],
          ],
        },
      })
    );
  }

  pushGuarantee(guarantee) {
    const isActive = this.props.id.startsWith("Active");

    this.setState(
      update(this.state, {
        guarantees: {
          $push: [{ ...guarantee, isActive }],
        },
      })
    );
  }

  removeGuarantee(index) {
    this.setState(
      update(this.state, {
        guarantees: {
          $splice: [[index, 1]],
        },
      })
    );
  }

  render() {
    const { guarantees } = this.state;
    const { canDrop, disabled, isOver, connectDropTarget } = this.props;
    const containerClasses = classNames({
      "guarantee-container": true,
      active: canDrop && isOver,
    });

    return connectDropTarget(
      <div className={containerClasses}>
        <FieldArray
          formValues={this.props.formValues}
          name={`splits${this.props.id}`}
          component={RenderLineItems}
          id={this.props.id}
          props={{
            disabled: disabled,
            guarantees: guarantees,
            valueType: this.props.valueType,
            removeGuarantee: this.removeGuarantee,
            moveGuarantee: this.moveGuarantee,
          }}
        />
      </div>
    );
  }
}

const cardTarget = {
  drop(props, monitor, component) {
    const { id } = props;
    const sourceObj = monitor.getItem();

    let alreadyActive = false;

    if (
      !sourceObj.guarantee.isActive &&
      !sourceObj.guarantee.isOutOfOptimization
    ) {
      if (props.formValues.splitsActiveIn) {
        props.formValues.splitsActiveIn.map((guarantee) => {
          if (guarantee.guaranteeId == sourceObj.guarantee.guaranteeId) {
            alreadyActive = true;
          }
        });
      }

      if (props.formValues.splitsActiveOut) {
        props.formValues.splitsActiveOut.map((guarantee) => {
          if (guarantee.guaranteeId == sourceObj.guarantee.guaranteeId) {
            alreadyActive = true;
          }
        });
      }
    }

    if (alreadyActive) {
      props.setWarning("doubledGuarantee");
    } else {
      if (id !== sourceObj.listId) {
        component.pushGuarantee(sourceObj.guarantee);
      }
      props.setWarning("doubledGuarantee", false);
    }

    return {
      listId: !alreadyActive ? id : sourceObj.listId,
    };
  },
};

GuaranteeContainer.propTypes = {
  canDrop: PropTypes.bool,
  connectDropTarget: PropTypes.func,
  disabled: PropTypes.bool,
  formValues: PropTypes.object,
  id: PropTypes.string,
  isOver: PropTypes.bool,
  list: PropTypes.array,
  setWarning: PropTypes.func,
  valueType: PropTypes.string,
};

export default connect(null, null, null, { withRef: true })(
  DropTarget("GUARANTEE", cardTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  }))(GuaranteeContainer)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/classes/GuaranteeContainer.js